module.exports = __webpack_public_path__ + "static/media/settings.b826c90f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/settings.svg
// module id = 59
// module chunks = 0